export default __webpack_public_path__ + "static/media/darkorange.8fda90e0.png";